import { Injectable } from '@angular/core';
import { Http, Response, RequestOptions, HttpModule, Headers } from '@angular/http';
// import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { User } from '../../model/user.model';
import 'rxjs/add/operator/map';
import { BehaviorSubject } from 'rxjs';
import { UserFriendlyMsgs } from '../../app.user-msgs';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';

@Injectable()
export class UserService {
  loggedUser: string;
  url = environment.configURI;
  load;

  constructor( private http: Http,
    private userFriendlyMsgs: UserFriendlyMsgs,
    public httpClient: HttpClient) {
    this.load = new BehaviorSubject('initial');
  }

  loginUser(user: User) {
    const body = {
      emailID: user.loginID.toLowerCase(),
      password: user.password
    };
    
    //console.log(this.url + '/login');
    return this.httpClient.post('https://qaservices.parplatinumcompliance.com/QA/login', body);
  }

  logOutUser() {
    let body = {
      token: localStorage.getItem('Token')
    }
    return this.httpClient.post(this.url + '/logout', body).catch(this.userFriendlyMsgs.errorHandler);
  }

  refreshToken() {
    return this.httpClient.get(this.url + '/refreshToken').catch(this.userFriendlyMsgs.errorHandler);
  }

  userInfo() {
    return this.httpClient.get(this.url + '/userInfo').catch(this.userFriendlyMsgs.errorHandler);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/user/user.service.ts